const STATUS_VARIANTS = Object.freeze({
  success: new Set(['active', 'completed', 'approved', 'accepted', 'paid', 'confirmed', 'open']),
  warning: new Set(['pending', 'expiring soon', 'renewal needed']),
  danger: new Set(['cancelled', 'canceled', 'rejected', 'failed', 'blocked', 'suspended']),
  info: new Set(['frozen', 'paused', 'scheduled', 'in progress']),
  neutral: new Set(['inactive', 'draft', 'expired', 'closed', 'unknown']),
});

export function normalizeStatus(value) {
  if (value === null || value === undefined || value === '') return 'unknown';

  return String(value)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

export function statusVariant(value) {
  const normalized = normalizeStatus(value);
  const variant = Object.keys(STATUS_VARIANTS)
    .find((key) => STATUS_VARIANTS[key].has(normalized));
  return variant || 'neutral';
}

export { STATUS_VARIANTS };
